import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from '@/translations/en.json'
import de from '@/translations/de.json'

export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'it', 'es'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]

export const LOCALE_LABELS = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  es: 'Español',
} as const satisfies Record<Locale, string>

export const toLocale = (lng: string): Locale => {
  const base = lng.split('-')[0] ?? ''
  return (SUPPORTED_LOCALES as readonly string[]).includes(base)
    ? (base as Locale)
    : 'en'
}

export const changeLocale = (locale: Locale): Promise<void> =>
  i18n.changeLanguage(locale).then(() => undefined)

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // @TODO: Add more languages to the resources object as they are translated.
    resources: {
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALES,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'piranha.locale',
      lookupCookie: 'num26locale',
      caches: ['localStorage'],
    },
  })

export default i18n
